// Higher-order function for rotating points
import rotatePoints from './rotatePoints.js';

const rotatePointsAbout = (angle, origin = [0, 0]) => points =>
  rotatePoints(points, angle, origin);

export default rotatePointsAbout;